var cov_2oo2sazsi7 = function () {
  var path = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Table/resizable.tsx",
      hash = "072ee949f07a7d8dd4d8cea89cb1be5010d93774",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Table/resizable.tsx",
    statementMap: {
      "0": {
        start: {
          line: 10,
          column: 2
        },
        end: {
          line: 73,
          column: 3
        }
      },
      "1": {
        start: {
          line: 12,
          column: 6
        },
        end: {
          line: 12,
          column: 18
        }
      },
      "2": {
        start: {
          line: 13,
          column: 6
        },
        end: {
          line: 13,
          column: 54
        }
      },
      "3": {
        start: {
          line: 14,
          column: 6
        },
        end: {
          line: 17,
          column: 7
        }
      },
      "4": {
        start: {
          line: 21,
          column: 26
        },
        end: {
          line: 21,
          column: 43
        }
      },
      "5": {
        start: {
          line: 22,
          column: 42
        },
        end: {
          line: 22,
          column: 52
        }
      },
      "6": {
        start: {
          line: 23,
          column: 6
        },
        end: {
          line: 38,
          column: 7
        }
      },
      "7": {
        start: {
          line: 24,
          column: 8
        },
        end: {
          line: 37,
          column: 9
        }
      },
      "8": {
        start: {
          line: 26,
          column: 10
        },
        end: {
          line: 26,
          column: 36
        }
      },
      "9": {
        start: {
          line: 28,
          column: 26
        },
        end: {
          line: 34,
          column: 16
        }
      },
      "10": {
        start: {
          line: 31,
          column: 16
        },
        end: {
          line: 33,
          column: 18
        }
      },
      "11": {
        start: {
          line: 32,
          column: 18
        },
        end: {
          line: 32,
          column: 64
        }
      },
      "12": {
        start: {
          line: 36,
          column: 10
        },
        end: {
          line: 36,
          column: 45
        }
      },
      "13": {
        start: {
          line: 42,
          column: 24
        },
        end: {
          line: 42,
          column: 34
        }
      },
      "14": {
        start: {
          line: 43,
          column: 6
        },
        end: {
          line: 43,
          column: 68
        }
      },
      "15": {
        start: {
          line: 43,
          column: 37
        },
        end: {
          line: 43,
          column: 68
        }
      },
      "16": {
        start: {
          line: 44,
          column: 6
        },
        end: {
          line: 44,
          column: 18
        }
      },
      "17": {
        start: {
          line: 48,
          column: 6
        },
        end: {
          line: 48,
          column: 40
        }
      },
      "18": {
        start: {
          line: 48,
          column: 34
        },
        end: {
          line: 48,
          column: 40
        }
      },
      "19": {
        start: {
          line: 49,
          column: 33
        },
        end: {
          line: 49,
          column: 43
        }
      },
      "20": {
        start: {
          line: 50,
          column: 22
        },
        end: {
          line: 59,
          column: 8
        }
      },
      "21": {
        start: {
          line: 51,
          column: 23
        },
        end: {
          line: 51,
          column: 43
        }
      },
      "22": {
        start: {
          line: 53,
          column: 8
        },
        end: {
          line: 53,
          column: 81
        }
      },
      "23": {
        start: {
          line: 54,
          column: 8
        },
        end: {
          line: 54,
          column: 31
        }
      },
      "24": {
        start: {
          line: 55,
          column: 8
        },
        end: {
          line: 58,
          column: 10
        }
      },
      "25": {
        start: {
          line: 56,
          column: 20
        },
        end: {
          line: 56,
          column: 31
        }
      },
      "26": {
        start: {
          line: 57,
          column: 10
        },
        end: {
          line: 57,
          column: 30
        }
      },
      "27": {
        start: {
          line: 57,
          column: 17
        },
        end: {
          line: 57,
          column: 30
        }
      },
      "28": {
        start: {
          line: 60,
          column: 6
        },
        end: {
          line: 63,
          column: 7
        }
      },
      "29": {
        start: {
          line: 61,
          column: 8
        },
        end: {
          line: 61,
          column: 39
        }
      },
      "30": {
        start: {
          line: 62,
          column: 8
        },
        end: {
          line: 62,
          column: 14
        }
      },
      "31": {
        start: {
          line: 64,
          column: 6
        },
        end: {
          line: 64,
          column: 28
        }
      },
      "32": {
        start: {
          line: 68,
          column: 26
        },
        end: {
          line: 68,
          column: 36
        }
      },
      "33": {
        start: {
          line: 69,
          column: 43
        },
        end: {
          line: 69,
          column: 53
        }
      },
      "34": {
        start: {
          line: 70,
          column: 20
        },
        end: {
          line: 70,
          column: 35
        }
      },
      "35": {
        start: {
          line: 71,
          column: 6
        },
        end: {
          line: 71,
          column: 103
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 9,
            column: 16
          },
          end: {
            line: 9,
            column: 17
          }
        },
        loc: {
          start: {
            line: 10,
            column: 2
          },
          end: {
            line: 73,
            column: 3
          }
        },
        line: 10
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 11,
            column: 4
          },
          end: {
            line: 11,
            column: 5
          }
        },
        loc: {
          start: {
            line: 11,
            column: 56
          },
          end: {
            line: 18,
            column: 5
          }
        },
        line: 11
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 20,
            column: 4
          },
          end: {
            line: 20,
            column: 5
          }
        },
        loc: {
          start: {
            line: 20,
            column: 67
          },
          end: {
            line: 39,
            column: 5
          }
        },
        line: 20
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 30,
            column: 29
          },
          end: {
            line: 30,
            column: 30
          }
        },
        loc: {
          start: {
            line: 30,
            column: 38
          },
          end: {
            line: 34,
            column: 15
          }
        },
        line: 30
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 31,
            column: 30
          },
          end: {
            line: 31,
            column: 31
          }
        },
        loc: {
          start: {
            line: 31,
            column: 49
          },
          end: {
            line: 33,
            column: 17
          }
        },
        line: 31
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 41,
            column: 4
          },
          end: {
            line: 41,
            column: 5
          }
        },
        loc: {
          start: {
            line: 41,
            column: 15
          },
          end: {
            line: 45,
            column: 5
          }
        },
        line: 41
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 47,
            column: 4
          },
          end: {
            line: 47,
            column: 5
          }
        },
        loc: {
          start: {
            line: 47,
            column: 67
          },
          end: {
            line: 65,
            column: 5
          }
        },
        line: 47
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 50,
            column: 40
          },
          end: {
            line: 50,
            column: 41
          }
        },
        loc: {
          start: {
            line: 50,
            column: 49
          },
          end: {
            line: 59,
            column: 7
          }
        },
        line: 50
      },
      "8": {
        name: "(anonymous_8)",
        decl: {
          start: {
            line: 55,
            column: 30
          },
          end: {
            line: 55,
            column: 31
          }
        },
        loc: {
          start: {
            line: 55,
            column: 42
          },
          end: {
            line: 58,
            column: 9
          }
        },
        line: 55
      },
      "9": {
        name: "(anonymous_9)",
        decl: {
          start: {
            line: 67,
            column: 4
          },
          end: {
            line: 67,
            column: 5
          }
        },
        loc: {
          start: {
            line: 67,
            column: 13
          },
          end: {
            line: 72,
            column: 5
          }
        },
        line: 67
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 23,
            column: 6
          },
          end: {
            line: 38,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 23,
            column: 6
          },
          end: {
            line: 38,
            column: 7
          }
        }, {
          start: {
            line: 23,
            column: 6
          },
          end: {
            line: 38,
            column: 7
          }
        }],
        line: 23
      },
      "1": {
        loc: {
          start: {
            line: 24,
            column: 8
          },
          end: {
            line: 37,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 24,
            column: 8
          },
          end: {
            line: 37,
            column: 9
          }
        }, {
          start: {
            line: 24,
            column: 8
          },
          end: {
            line: 37,
            column: 9
          }
        }],
        line: 24
      },
      "2": {
        loc: {
          start: {
            line: 28,
            column: 26
          },
          end: {
            line: 34,
            column: 16
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 29,
            column: 14
          },
          end: {
            line: 29,
            column: 21
          }
        }, {
          start: {
            line: 30,
            column: 14
          },
          end: {
            line: 34,
            column: 16
          }
        }],
        line: 28
      },
      "3": {
        loc: {
          start: {
            line: 43,
            column: 6
          },
          end: {
            line: 43,
            column: 68
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 43,
            column: 6
          },
          end: {
            line: 43,
            column: 68
          }
        }, {
          start: {
            line: 43,
            column: 6
          },
          end: {
            line: 43,
            column: 68
          }
        }],
        line: 43
      },
      "4": {
        loc: {
          start: {
            line: 48,
            column: 6
          },
          end: {
            line: 48,
            column: 40
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 48,
            column: 6
          },
          end: {
            line: 48,
            column: 40
          }
        }, {
          start: {
            line: 48,
            column: 6
          },
          end: {
            line: 48,
            column: 40
          }
        }],
        line: 48
      },
      "5": {
        loc: {
          start: {
            line: 53,
            column: 43
          },
          end: {
            line: 53,
            column: 79
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 53,
            column: 43
          },
          end: {
            line: 53,
            column: 55
          }
        }, {
          start: {
            line: 53,
            column: 59
          },
          end: {
            line: 53,
            column: 74
          }
        }, {
          start: {
            line: 53,
            column: 78
          },
          end: {
            line: 53,
            column: 79
          }
        }],
        line: 53
      },
      "6": {
        loc: {
          start: {
            line: 57,
            column: 10
          },
          end: {
            line: 57,
            column: 30
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 57,
            column: 10
          },
          end: {
            line: 57,
            column: 30
          }
        }, {
          start: {
            line: 57,
            column: 10
          },
          end: {
            line: 57,
            column: 30
          }
        }],
        line: 57
      },
      "7": {
        loc: {
          start: {
            line: 60,
            column: 6
          },
          end: {
            line: 63,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 60,
            column: 6
          },
          end: {
            line: 63,
            column: 7
          }
        }, {
          start: {
            line: 60,
            column: 6
          },
          end: {
            line: 63,
            column: 7
          }
        }],
        line: 60
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0, 0],
      "6": [0, 0],
      "7": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import _objectWithoutProperties from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _classCallCheck from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
var _jsxFileName = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Table/resizable.tsx";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React from 'react';
import immer from 'immer';
export default (function (Table) {
  cov_2oo2sazsi7.f[0]++;
  cov_2oo2sazsi7.s[0]++;
  return (
    /*#__PURE__*/
    function (_React$Component) {
      _inherits(_class, _React$Component);

      var _super = _createSuper2(_class);

      function _class(props) {
        var _this;

        _classCallCheck(this, _class);

        cov_2oo2sazsi7.f[1]++;
        cov_2oo2sazsi7.s[1]++;
        _this = _super.call(this, props);
        cov_2oo2sazsi7.s[2]++;
        _this.handleResize = _this.handleResize.bind(_assertThisInitialized(_this));
        cov_2oo2sazsi7.s[3]++;
        _this.state = {
          columns: props.columns,
          delta: 0
        };
        return _this;
      }

      _createClass(_class, [{
        key: "componentDidUpdate",
        value: function componentDidUpdate(prevProps) {
          var _this2 = this;

          cov_2oo2sazsi7.f[2]++;
          var prevColumns = (cov_2oo2sazsi7.s[4]++, prevProps.columns);

          var _ref = (cov_2oo2sazsi7.s[5]++, this.props),
              columns = _ref.columns,
              onColumnResize = _ref.onColumnResize;

          cov_2oo2sazsi7.s[6]++;

          if (prevColumns !== columns) {
            cov_2oo2sazsi7.b[0][0]++;
            cov_2oo2sazsi7.s[7]++;

            if (prevColumns.length !== columns.length) {
              cov_2oo2sazsi7.b[1][0]++;
              cov_2oo2sazsi7.s[8]++;
              // eslint-disable-next-line react/no-did-update-set-state
              this.setState({
                columns: columns
              });
            } else {
              cov_2oo2sazsi7.b[1][1]++;
              var widthed = (cov_2oo2sazsi7.s[9]++, onColumnResize ? (cov_2oo2sazsi7.b[2][0]++, columns) : (cov_2oo2sazsi7.b[2][1]++, immer(columns, function (draft) {
                cov_2oo2sazsi7.f[3]++;
                cov_2oo2sazsi7.s[10]++;
                draft.forEach(function (column, index) {
                  cov_2oo2sazsi7.f[4]++;
                  cov_2oo2sazsi7.s[11]++;
                  column.width = _this2.state.columns[index].width;
                });
              }))); // eslint-disable-next-line react/no-did-update-set-state

              cov_2oo2sazsi7.s[12]++;
              this.setState({
                columns: widthed
              });
            }
          } else {
            cov_2oo2sazsi7.b[0][1]++;
          }
        }
      }, {
        key: "getWidth",
        value: function getWidth() {
          cov_2oo2sazsi7.f[5]++;

          var _ref2 = (cov_2oo2sazsi7.s[13]++, this.props),
              width = _ref2.width;

          cov_2oo2sazsi7.s[14]++;

          if (typeof width === 'number') {
            cov_2oo2sazsi7.b[3][0]++;
            cov_2oo2sazsi7.s[15]++;
            return width + this.state.delta;
          } else {
            cov_2oo2sazsi7.b[3][1]++;
          }

          cov_2oo2sazsi7.s[16]++;
          return width;
        }
      }, {
        key: "handleResize",
        value: function handleResize(index, width, colgroup) {
          cov_2oo2sazsi7.f[6]++;
          cov_2oo2sazsi7.s[17]++;

          if (colgroup === undefined) {
            cov_2oo2sazsi7.b[4][0]++;
            cov_2oo2sazsi7.s[18]++;
            return;
          } else {
            cov_2oo2sazsi7.b[4][1]++;
          }

          var _ref3 = (cov_2oo2sazsi7.s[19]++, this.props),
              onColumnResize = _ref3.onColumnResize;

          var changed = (cov_2oo2sazsi7.s[20]++, immer(this.state, function (draft) {
            cov_2oo2sazsi7.f[7]++;
            var column = (cov_2oo2sazsi7.s[21]++, draft.columns[index]); // @ts-ignore

            cov_2oo2sazsi7.s[22]++;
            draft.delta += parseFloat(width - ((cov_2oo2sazsi7.b[5][0]++, column.width) || (cov_2oo2sazsi7.b[5][1]++, colgroup[index]) || (cov_2oo2sazsi7.b[5][2]++, 0)));
            cov_2oo2sazsi7.s[23]++;
            colgroup[index] = width;
            cov_2oo2sazsi7.s[24]++;
            draft.columns.forEach(function (col, i) {
              cov_2oo2sazsi7.f[8]++;
              var w = (cov_2oo2sazsi7.s[25]++, colgroup[i]);
              cov_2oo2sazsi7.s[26]++;

              if (w) {
                cov_2oo2sazsi7.b[6][0]++;
                cov_2oo2sazsi7.s[27]++;
                col.width = w;
              } else {
                cov_2oo2sazsi7.b[6][1]++;
              }
            });
          }));
          cov_2oo2sazsi7.s[28]++;

          if (onColumnResize) {
            cov_2oo2sazsi7.b[7][0]++;
            cov_2oo2sazsi7.s[29]++;
            onColumnResize(changed.columns);
            cov_2oo2sazsi7.s[30]++;
            return;
          } else {
            cov_2oo2sazsi7.b[7][1]++;
          }

          cov_2oo2sazsi7.s[31]++;
          this.setState(changed);
        }
      }, {
        key: "render",
        value: function render() {
          cov_2oo2sazsi7.f[9]++;

          var _ref4 = (cov_2oo2sazsi7.s[32]++, this.state),
              columns = _ref4.columns;

          var _ref5 = (cov_2oo2sazsi7.s[33]++, this.props),
              onColumnResize = _ref5.onColumnResize,
              other = _objectWithoutProperties(_ref5, ["onColumnResize"]);

          var width = (cov_2oo2sazsi7.s[34]++, this.getWidth());
          cov_2oo2sazsi7.s[35]++;
          return (
            /*#__PURE__*/
            React.createElement(Table, Object.assign({}, other, {
              width: width,
              columns: columns,
              onResize: this.handleResize,
              __self: this,
              __source: {
                fileName: _jsxFileName,
                lineNumber: 71,
                columnNumber: 14
              }
            }))
          );
        }
      }]);

      return _class;
    }(React.Component)
  );
});